import styled from "styled-components";
import Card from "@mui/material/Card";
import DefaultUptimeTheme from "component/theme/defaultTheme";

export const eyebrow = (theme: typeof DefaultUptimeTheme) => `
  font-size: ${theme.uptimeDynamicFontSize?.eyeBrow};
  letter-spacing: .${theme.uptimeSpace[1]}px;
  font-weight: normal;
`;

export const buttonLink = (theme: any) => `
  font-size: ${theme.uptimeDynamicFontSize?.deviceCard?.txtLink};
  line-height: ${theme.uptimeLineHeights.mobile.lh4}px;
  font-weight: 600;
`;

export const captionRegularAndSemibold = (theme: any) => `
  //include captionSemibold & captionSemibold;
  font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
  line-height: ${theme.uptimeDynamicAlignCenter?.deviceAndAcknowledgeCard?.lineHeightConfigItem ?? `${theme.uptimeLineHeights.desktop.lh3}px`};
`;

export const heading5 = (theme: any) => `
  font-size: ${theme.uptimeDynamicFontSize?.deviceCard?.deviceName};
  line-height: ${theme.uptimeDynamicAlignCenter?.deviceAndAcknowledgeCard?.lineHeightName ?? 'initial'};
  font-weight: normal;
  @media (min-width: 960px) {
    font-size: ${theme.uptimeFontSizes.desktop.fz7}px;
  }
`;

export const max1lines = `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const max2lines = `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const myStuffSmallCard = (theme: any) => `
  height: 136px;
  background: ${theme.uptimeColors.grayScales.white};
`;

export const CardStyle = styled(Card)`
  min-height: 300px;
  height: 300px;
  display: grid;
  border-radius: 10px !important;
  position: relative;
`;

export const DeviceCardStyle = styled.div`
  ${({ theme }) => `
  .my-stuff-divider-bar {
    width: 2px!important;
  }
  
  .device-card-header, .device-card-content{
    padding: ${theme.uptimeSpace[0]} ${theme.uptimeSpace[8]}px;
    width: 100%;
  }
  .device-card-header{
    padding-top: ${theme.uptimeSpace[6]}px;
  }
  .device-card-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    padding: 12px 8px;
    .my-stuff-card-link-text {
      margin: ${theme.uptimeSpace[0]};
      width: 100%;
      text-align: center;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      margin-top: ${theme.uptimeDynamicAlignCenter?.deviceAndAcknowledgeCard?.marginTopLinkText ?? 0} !important;
      > span {
        ${buttonLink(theme)}
        &:hover {
          cursor: pointer;
          color: ${theme.uptimeColors.grayScales.darkerGray};
          text-decoration: underline;
        }
      }
    }
  }
  
    
  .my-stuff-card-body {
    .my-stuff-card-configuration-item{
      display: flex;
      align-items: center;
      justify-content: left;
      font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
      margin-bottom: ${theme.uptimeSpace[2]}px;
      flex-wrap: nowrap;
  
      .MuiSvgIcon-root {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-right: ${theme.uptimeSpace[4]}px;
      }
  
      .my-stuff-card-configuration-item-header {
        ${captionRegularAndSemibold(theme)};
        white-space: nowrap;
        font-weight: bold;
        margin-right: ${theme.uptimeSpace[2]}px;
      }
  
      .my-stuff-card-configuration-item-content {
        color: ${theme.uptimeColors.grayScales.darkerGray};
        word-break: break-all;
        ${max1lines};
        ${captionRegularAndSemibold(theme)};
      }
    }
  }
  
  .my-stuff-card-body-type {
    ${captionRegularAndSemibold(theme)};
    color: ${theme.uptimeColors.grayScales.darkerGray};
    text-transform: uppercase;
    margin-bottom: 0;
    min-height: 20px;
    margin-block-start: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  
  .my-stuff-card-body-name {
    margin-top: ${theme.uptimeSpace[0]} !important;
    margin-bottom: ${theme.uptimeSpace[2]}px;
    min-height: 20px !important;
    -webkit-line-clamp: 1 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${heading5(theme)};
  }
  
  .my-stuff-card-body-status {
    ${captionRegularAndSemibold(theme)};
    ${max2lines};
    word-break: break-word;
    font-weight: 600;
    color: ${theme.uptimeColors.grayScales.darkerGray};
  }
  
  .ELIGIBLE_FOR_REFRESH {
    > div:first-child {
      height: 6px;
      margin: ${theme.uptimeSpace[0]} ${theme.uptimeSpace[0]} ${
    theme.uptimeSpace[2]
  }px;
    }
  }
`}
`;
